import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CalendarioItem } from '../../../shared/models/calendario.model';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Config, emptyConfig, ConfigFacade } from '@funceme/core-app';
import limites from './limites-categoria.json';
import { CalendarioGraficoSerieComponent } from '../calendario-grafico-serie/calendario-grafico-serie.component';
import { Router } from '@angular/router';
import { CalendarioTituloComponent } from '../calendario-titulo/calendario-titulo.component';
import { ArrayType } from '@angular/compiler';

@Component({
  selector: 'app-calendario-tabela',
  templateUrl: './calendario-tabela.component.html',
  styleUrls: ['./calendario-tabela.component.css']
})
export class CalendarioTabelaComponent implements OnInit {

  private _data = new BehaviorSubject<CalendarioItem[]>([]);

  private alldata;
  private limites = limites;

  @Input()
  set data(value) {
    this._data.next(value);
  };

  get data() {
    return this._data.getValue();
  }

  private _config = new BehaviorSubject<Config>(emptyConfig);

  @Input()
  set config(value) {
    this._config.next(value);
  };

  get config() {
    return this._config.getValue();
  }

  public title = 'Nome';

  public municipios: any[] = [];
  public municipios2: any[] = [];
  public regioes: any[] = [];

  public dataQuantis = [];

  public selectedMunicipio: string;
  public selectedRegiao: string;
  public filterNome: string;

  public displayedColumns: string[] = [];

  public dataSource = new MatTableDataSource<CalendarioItem>();
  public pathArr = [];
  public fileName:string;
  public hideColunmsOnExport = '';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private configFacade: ConfigFacade, public dialog: MatDialog, private router: Router) {
    this.configFacade.findKey$.subscribe(value => {
      this.selectedRegiao = '';
      if (this.municipios2 && this.municipios2.length > 0)
      {
        this.selectedMunicipio = this.municipios2.find(item => item.toLowerCase() == value.toLowerCase());
        this.filterNome = ''
      }
      else
        this.filterNome = value;

      this.applyFilter(this.filterNome);
    });
    this.pathArr = this.router.url.slice(1).split('/');

    if(this.router.url.includes('ano')){
      this.fileName = this.pathArr[1]+'_'+this.pathArr[2]+'_'+this.pathArr[0]+'_'+this.pathArr[3];
    } else {
      this.fileName = this.pathArr[1]+'_'+this.pathArr[2]+'_'+this.pathArr[0]+'_'+this.pathArr[4]+'_'+this.pathArr[3];
    }

  }

  printMunicipio(municipio) {

    if (this.municipios2.includes(municipio) || this.municipios.includes(municipio) || this.config.metrica == 'media') {
      return municipio;
    }
    return municipio + ' (Sem informação)';
  }


  async ngOnInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.data = [];
    this.dataSource.filterPredicate = (data: CalendarioItem, filter: string) => {

      if (filter == ';;')
        return true;

      const parts = filter.split(';');

      let _nome = false;
      let _municipio = false;
      let _regiao = false;

      if (this.config.metrica == 'maxima')
      {
        if (parts[1] == '' || (data.municipio && data.municipio == parts[1]))
          _municipio = true;
        if (parts[2] == '' || (data.regiao && data.regiao == parts[2]))
          _regiao = true;
        if (parts[0] == '' || (data.nome.trim().toLowerCase().indexOf(parts[0]) != -1))
          _nome = true;
          if (_nome && _municipio && _regiao)
            return true;
          else
            return false;
      }
      else if (this.config.metrica == 'media')
      {
        if (parts[1] == '' || (data.nome && data.nome == parts[1]))
          _municipio = true;
        if (parts[2] == '' || (data.regiao && data.regiao == parts[2]))
          _regiao = true;
        if (parts[0] == '' || (data.nome.trim().toLowerCase().indexOf(parts[0]) != -1))
          _nome = true;
        if (_nome && _municipio && _regiao)
          return true;
        else
          return false;
      }
      return true;


    }

    this._data.subscribe(values => {
      this.dataSource.data = values;
      this.alldata = values;

      this.dataSource.data.forEach((data: any) => {
        data.media_dia = data.observado
        data.observado_media = data.observado
      })

      if (this.config.periodo != 'dia' && (this.config.produto == 'ceara' || this.config.produto == 'macrorregioes' || this.config.produto == 'regioes' || this.config.produto == 'municipios')) {
        let limites;

        if (this.config.periodo == 'ano')
          limites = this.limites[this.config.produto][this.config.periodo];
        else
          limites = this.limites[this.config.produto][this.config.periodo][this.config.mes];


        this.dataSource.data.forEach((data: any) => {
          data.categoria = this.getCategoria(data.observado, limites[data.nome]);
          data.resumo = data.categoria.texto;
          this.dataQuantis[data.nome] = { data: data.observado, limites: limites[data.nome] }
        })
      }

      if (this.config.produto == 'municipios')
      {
        this.municipios2 = ["Abaiara", "Acarape", "Acaraú", "Acopiara", "Aiuaba", "Alcântaras", "Altaneira", "Alto Santo", "Amontada", "Antonina do Norte", "Apuiarés", "Aquiraz", "Aracati", "Aracoiaba", "Ararendá", "Araripe", "Aratuba", "Arneiroz", "Assaré", "Aurora", "Baixio", "Banabuiú", "Barbalha", "Barreira", "Barro", "Barroquinha", "Baturité", "Beberibe", "Bela Cruz", "Boa Viagem", "Brejo Santo", "Camocim", "Campos Sales", "Canindé", "Capistrano", "Caridade", "Cariré", "Caririaçu", "Cariús", "Carnaubal", "Cascavel", "Catarina", "Catunda", "Caucaia", "Cedro", "Chaval", "Choró", "Chorozinho", "Coreaú", "Crateús", "Crato", "Croatá", "Cruz", "Deputado Irapuan Pinheiro", "Ererê", "Eusébio", "Farias Brito", "Forquilha", "Fortaleza", "Fortim", "Frecheirinha", "General Sampaio", "Graça", "Granja", "Granjeiro", "Groaíras", "Guaiúba", "Guaraciaba do Norte", "Guaramiranga", "Hidrolândia", "Horizonte", "Ibaretama", "Ibiapina", "Ibicuitinga", "Icapuí", "Icó", "Iguatu", "Independência", "Ipaporanga", "Ipaumirim", "Ipu", "Ipueiras", "Iracema", "Irauçuba", "Itaiçaba", "Itaitinga", "Itapajé", "Itapipoca", "Itapiúna", "Itarema", "Itatira", "Jaguaretama", "Jaguaribara", "Jaguaribe", "Jaguaruana", "Jardim", "Jati", "Jijoca de Jericoacoara", "Juazeiro do Norte", "Jucás", "Lavras da Mangabeira", "Limoeiro do Norte", "Madalena", "Maracanaú", "Maranguape", "Marco", "Martinópole", "Massapê", "Mauriti", "Meruoca", "Milagres", "Milhã", "Miraíma", "Missão Velha", "Mombaça", "Monsenhor Tabosa", "Morada Nova", "Moraújo", "Morrinhos", "Mucambo", "Mulungu", "Nova Olinda", "Nova Russas", "Novo Oriente", "Ocara", "Orós", "Pacajus", "Pacatuba", "Pacoti", "Pacujá", "Palhano", "Palmácia", "Paracuru", "Paraipaba", "Parambu", "Paramoti", "Pedra Branca", "Penaforte", "Pentecoste", "Pereiro", "Pindoretama", "Piquet Carneiro", "Pires Ferreira", "Poranga", "Porteiras", "Potengi", "Potiretama", "Quiterianópolis", "Quixadá", "Quixelô", "Quixeramobim", "Quixeré", "Redenção", "Reriutaba", "Russas", "Saboeiro", "Salitre", "Santana do Acaraú", "Santana do Cariri", "Santa Quitéria", "São Benedito", "São Gonçalo do Amarante", "São João do Jaguaribe", "São Luís do Curu", "Senador Pompeu", "Senador Sá", "Sobral", "Solonópole", "Tabuleiro do Norte", "Tamboril", "Tarrafas", "Tauá", "Tejuçuoca", "Tianguá", "Trairi", "Tururu", "Ubajara", "Umari", "Umirim", "Uruburetama", "Uruoca", "Varjota", "Várzea Alegre", "Viçosa do Ceará"];
      }
      this.regioes = [];

      values.map(item => {
        if (!!item.municipio && this.municipios.indexOf(item.municipio) == -1)
          this.municipios.push(item.municipio);

        if (!!item.regiao && this.regioes.indexOf(item.regiao) == -1)
          this.regioes.push(item.regiao);
      });
      this.municipios.sort();
      this.municipios2.sort()
      this.regioes.sort();

      this.selectedMunicipio = '';
      this.selectedRegiao = '';
      this.filterNome = '';

      this.limpar();
      this.applyFilter('');
    });

    this._config.subscribe(value => {
      this.displayedColumns = this.getDisplayedColumns(value);
      this.title = this.getTitle(value);
    });
  }

  applyFilter(filterValue: string) {
    if (!this.alldata && this.dataSource.data.length > 1) {
      this.alldata = [];
      this.dataSource.data.forEach(d => this.alldata.push(d));
    }

    if (filterValue)
      this.filterNome = filterValue.trim().toLowerCase();
    else
      this.filterNome = '';

    if (this.alldata && this.filterNome + ';' + this.selectedMunicipio + ';' + this.selectedRegiao == ";;")
      this.dataSource.data = this.alldata;

    this.dataSource.filter = this.filterNome + ';' + this.selectedMunicipio + ';' + this.selectedRegiao;
  }

  public changedFilter() {
    if (!this.selectedMunicipio)
      this.selectedMunicipio = '';

    if (!this.selectedRegiao)
      this.selectedRegiao = '';


    this.applyFilter(this.filterNome);
  }

  private getDisplayedColumns(config: Config): string[] {
    if (config.metrica == 'maxima') {
      if (config.produto == 'municipios')

        if (config.periodo == 'dia'){
          this.hideColunmsOnExport = '4,5';
          return ['nome', 'municipio', 'regiao', 'observado', 'series', 'grafico'];
        }
        else
          return ['nome', 'municipio', 'regiao', 'normal', 'observado', 'desvio'];

      else if (config.produto == 'ceara')
        return ['nome', 'normal', 'observado', 'desvio'];

      else
        return ['nome', 'regiao', 'observado'];


    } else if (config.metrica == 'media') {
      if (config.produto == 'municipios') {

        if (config.periodo == 'dia')
          return ['nome', 'regiao', 'min', 'media_dia', 'max'];
        else
          return ['nome', 'regiao', 'normal', 'observado_media', 'desvio', 'categoria', 'limites'];

      } else if (config.produto == 'ceara' || config.produto == 'macrorregioes' || config.produto == 'regioes') {
        if (config.periodo == 'dia')
          return ['nome', 'min', 'media_dia', 'max'];
        else {
          this.hideColunmsOnExport = '4';
          return ['nome', 'normal', 'observado_media', 'desvio', 'categoria', 'limites', 'resumo'];
        }

      } else {
        if (config.periodo == 'dia')
          return ['nome', 'min', 'media_dia', 'max'];
        else
          return ['nome', 'normal', 'observado_media', 'desvio'];
      }
    }
  }

  private getTitle(config: Config): string {
    if (config.metrica == 'maxima' && config.produto == 'municipios')
      return 'Posto';

    switch (config.produto) {
      case 'municipios':
        return 'Município';
      case 'regioes':
        return 'Região hidrográfica';
      case 'bacias':
        return 'Bacia';
      case 'macrorregioes':
        return 'Macrorregião';
      case 'ceara':
        return 'Ceará';
    }
  }

  limpar() {
    this.configFacade.find('');
    this.filterNome = '';
    this.selectedMunicipio = '';
    this.selectedRegiao = '';
    this.applyFilter(this.filterNome);
  }

  getCategoria(media, limites) {
    if (media >= limites.superior)
      return { texto: "Acima da média", limites: limites, color: '#0064b4' }
    else if (media < limites.inferior)
      return { texto: "Abaixo da média", limites: limites, color: '#f73939' }
    else
      return { texto: "Em torno da média", limites: limites, color: '#5C9C5C' }
  }

  navegate(id) {
    let series_baseref = "https://cdn.funceme.br/calendario/postos/"
    window.open(series_baseref + id + '.txt', '_blank');
  }

  openDialog(id, nome) {
    const dialogRef = this.dialog.open(CalendarioGraficoSerieComponent, {
      data: { id: id, nome: nome, mes: this.config.mes, ano: this.config.ano }
    });
  }
}
